import 'react'

import { routes } from 'helpers/routes'

import TicketPage from 'pages/ticket'
import ComponyPage from 'pages/company'
import ComponyCreatePage from 'pages/companyCreate'
import CompanyEditPage from 'pages/companyEdit'
import CompanyDetail from 'pages/companyDetail'
import BranchPage from 'pages/branch'
import BranchDetail from 'pages/branchDetail'
import BranchEditPage from 'pages/branchEdit'
import BranchCreatePage from 'pages/branchCreate'
import ProductPage from 'pages/product'
import ProductCreatePage from 'pages/productCreate'
import ProductEditPage from 'pages/productEdit'
import ProductDetailPage from 'pages/productDetail'
import StockKeepingUnitPage from 'pages/stockKeepingUnit'
import StockKeepingUnitCreatePage from 'pages/stockKeepingUnitCreate'
import StockKeepingUnitDetailPage from 'pages/stockKeepingUnitDetail'
import StockKeepingUnitEditPage from 'pages/stockKeepingUnitEdit'
import StaffPage from 'pages/staff'
import StaffEditPage from 'pages/staffEdit'
import ProfileEditPage from 'pages/profileEdit'
import TicketDetailPage from 'pages/ticketDetail'
import TicketCreatePage from 'pages/ticketCreate'
import TicketSelectBranchPage from 'pages/ticketSelectBranch'
import TicketReceivedNotification from 'pages/ticketReceivedNotification'

import TicketAssignmentPage from 'pages/ticketAssignment'

export const routeOptions = [
  // ticket
  {
    path: routes.ticket.path,
    component: TicketPage,
    exact: true,
  },
  { path: routes.ticket.detail.path, component: TicketDetailPage, exact: true },
  {
    path: routes.ticket.receivedNotification.path,
    component: TicketReceivedNotification,
    exact: true,
  },
  {
    path: routes.ticket.branch.create.path,
    component: TicketCreatePage,
    exact: true,
  },
  {
    path: routes.ticket.branch.path,
    component: TicketSelectBranchPage,
    exact: true,
  },
  {
    path: routes.ticket.assign.path,
    component: TicketAssignmentPage,
    exact: true,
  },
  // company
  {
    path: routes.company.detail.path,
    component: CompanyDetail,
    exact: false,
  },
  {
    path: routes.company.edit.path,
    component: CompanyEditPage,
    exact: false,
  },
  {
    path: routes.company.create.path,
    component: ComponyCreatePage,
    exact: false,
  },
  {
    path: routes.company.path,
    component: ComponyPage,
    exact: false,
  },
  // branch
  {
    path: routes.branch.path,
    component: BranchPage,
    exact: true,
  },
  {
    path: routes.branch.detail.path,
    component: BranchDetail,
    exact: true,
  },
  {
    path: routes.branch.edit.path,
    component: BranchEditPage,
    exact: true,
  },
  {
    path: routes.branch.create.path,
    component: BranchCreatePage,
    exact: true,
  },
  {
    path: routes.branch.product.path,
    component: ProductPage,
    exact: true,
  },
  {
    path: routes.branch.product.create.path,
    component: ProductCreatePage,
    exact: true,
  },
  {
    path: routes.branch.product.edit.path,
    component: ProductEditPage,
    exact: true,
  },
  {
    path: routes.branch.product.detail.path,
    component: ProductDetailPage,
    exact: true,
  },
  // product
  {
    path: routes.product.detail.path,
    component: StockKeepingUnitDetailPage,
    exact: false,
  },
  {
    path: routes.product.edit.path,
    component: StockKeepingUnitEditPage,
    exact: false,
  },
  {
    path: routes.product.create.path,
    component: StockKeepingUnitCreatePage,
    exact: false,
  },
  {
    path: routes.product.path,
    component: StockKeepingUnitPage,
    exact: true,
  },
  // staff
  {
    path: routes.staff.path,
    component: StaffPage,
    exact: true,
  },
  {
    path: routes.staff.edit.path,
    component: StaffEditPage,
    exact: true,
  },
  // profile
  {
    path: routes.profile.edit.path,
    component: ProfileEditPage,
    exact: true,
  },
]
